const template = require('lodash/template');
const getFormData = require('get-form-data');

exports.init = function ModalWizard() {

  const $modal = $('#cost-center-modal, #project-modal, .js-modal-wizard');

  $modal.each(function (n, modal) {
    const $modal = $(modal);
    let step = 1;
    const steps = $modal.find('[class*="js-step"]');
    const form = $modal.find('form');
    const next = $modal.find('#next');
    const sendForm = $modal.find('#send-form');
    const confirmForm = $modal.find('#btn-confirmation');
    const previous = $modal.find('#previous');
    const checkboxSelectAll = $modal.find('#select-all');
    const checks = $modal.find('td.checkbox-cell input[type="checkbox"]');
    const templatesEl = $modal.find('[class*="js-is-template"]');

    if (templatesEl.length) {
      const templates = templatesEl.map(function (n, el) {
        return template(el.innerText);
      });

      const dealWithTemplates = function () {
        const formData = getFormData(form[0]);

        templatesEl.each(function (n, el) {

          el.innerText = templates[n]({
            form: formData
          });

        });
      };

      dealWithTemplates();
      form.find(':input').on('change', dealWithTemplates)
    }

    checkboxSelectAll.on('change', function checkboxSelectAllChangeHandler(e) {
      if (e.target.checked) {
        checks.prop('checked', true);
      } else {
        checks.prop('checked', false);
      }
    });

    const handleSteps = function handleSteps(toHide) {
      if (step <= steps.length) {
        previous.removeClass('hidden');
        next.removeClass('hidden');
      }

      if (step === 1) {
        previous.addClass('hidden');
      }

      if (step === steps.length) {
        next.addClass('hidden');
        sendForm.removeClass('hidden');
        confirmForm.removeClass('hidden');
      } else {
        next.removeClass('hidden');
        sendForm.addClass('hidden');
        confirmForm.addClass('hidden');
      }

      $modal.find('.js-step-' + toHide).addClass('hidden');
      $modal.find('.js-step-' + step).removeClass('hidden');
    };

    next.on('click', function next(e) {
      step++;
      handleSteps(step - 1);
    });

    previous.on('click', function previous(e) {
      step--;
      handleSteps(step + 1);
    });

    sendForm.on('click', function sendForm() {
      step = 1;

      $modal.find('[class*=js-step]').addClass('hidden');
      handleSteps();

      if (form.valid()) {
        nifty.body.overlay('show');

        const btnSubmitRecaptcha = $modal.find('#send-form-recaptcha');

        if (btnSubmitRecaptcha.length) {
          btnSubmitRecaptcha.trigger('click');
          const iframe = document.querySelector('iframe[src*="recaptcha"]');
          if (iframe) {
            const divRecaptcha = iframe.parentElement;
            document.body.classList.add('scroll-recaptcha');
            divRecaptcha.classList.add('recaptcha-resize');
          }
        } else {
          form.get(0).submit();
        }
      }
    });
  });
};

